/* istanbul ignore file */

export enum MediaResourceType {
  _3D_OBJECT = '3d_object',
  ANIMATION = 'gif',
  ASSET = 'asset',
  AUDIO = 'audio',
  CARD = 'card',
  DOCUMENT = 'document',
  FORM = 'form',
  IMAGE = 'image',
  LOCATION = 'location',
  PAGE = 'page',
  PERSON = 'person',
  SYSTEM_IMAGE = 'system_image',
  TABLE = 'Table',
  VIDEO = 'video',
}

export enum DamsMediaResourceType {
  AUDIO = 'Audio',
  DOCUMENT = 'Dokument',
  MODEL = 'Modell', // 3D-objects
  IMAGE = 'StillImage',
  VIDEO = 'Video',
  TABLE = 'Tabell',
}
